export default {
    statusPill: {
        draft: 'Osnutek',
        validated: 'Preverjeno',
        approved: 'Odobreno',
        locked: 'Zaklenjeno 🔒',
        cancelled: 'Preklicano',
    },
}
